var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8093 6.62361L18.1869 5.54352C17.6603 4.6296 16.4934 4.31432 15.5782 4.83872V4.83872C15.1426 5.09534 14.6228 5.16815 14.1334 5.04109C13.644 4.91402 13.2253 4.59752 12.9695 4.16137C12.805 3.88415 12.7166 3.56839 12.7132 3.24604V3.24604C12.7281 2.72922 12.5331 2.2284 12.1727 1.85767C11.8123 1.48694 11.3172 1.27786 10.8002 1.27808H9.54619C9.03965 1.27807 8.554 1.47991 8.19669 1.83895C7.83937 2.19798 7.63986 2.68459 7.6423 3.19112V3.19112C7.62728 4.23693 6.77517 5.07681 5.72925 5.0767C5.4069 5.07336 5.09114 4.98494 4.81392 4.82041V4.82041C3.89875 4.29601 2.7318 4.61129 2.20522 5.52522L1.53703 6.62361C1.0111 7.53639 1.32209 8.70261 2.23268 9.23231V9.23231C2.82459 9.57404 3.18922 10.2056 3.18922 10.8891C3.18922 11.5725 2.82459 12.2041 2.23268 12.5458V12.5458C1.32324 13.0719 1.01191 14.2353 1.53703 15.1454V15.1454L2.16861 16.2346C2.41533 16.6798 2.82929 17.0083 3.31888 17.1474C3.80847 17.2866 4.33333 17.2249 4.77731 16.976V16.976C5.21377 16.7213 5.73387 16.6516 6.22203 16.7822C6.71018 16.9128 7.12592 17.233 7.37685 17.6717C7.54138 17.9489 7.62979 18.2646 7.63314 18.587V18.587C7.63314 19.6435 8.48964 20.5 9.54619 20.5H10.8002C11.8532 20.5001 12.7082 19.6491 12.7132 18.5962V18.5962C12.7108 18.088 12.9116 17.6 13.2708 17.2407C13.6301 16.8814 14.1182 16.6807 14.6263 16.6831C14.9479 16.6917 15.2623 16.7798 15.5416 16.9394V16.9394C16.4544 17.4653 17.6206 17.1544 18.1503 16.2438V16.2438L18.8093 15.1454C19.0644 14.7075 19.1345 14.186 19.0039 13.6964C18.8733 13.2067 18.5529 12.7894 18.1137 12.5367V12.5367C17.6744 12.284 17.3541 11.8666 17.2235 11.3769C17.0929 10.8873 17.1629 10.3658 17.418 9.92796C17.5839 9.63834 17.8241 9.3982 18.1137 9.23231V9.23231C19.0188 8.70289 19.3291 7.54349 18.8093 6.63277V6.63277V6.62361Z",
    stroke: "#383E49",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.1752,
    cy: 10.8891,
    r: 2.63616,
    stroke: "#383E49",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/Setting.391be471293ad91bb01dfc96925c7abb.svg";
export { ForwardRef as ReactComponent };